import React, { useState, useEffect } from 'react';
import { Progress, Select } from '@backstage/core-components';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import { useApi } from '@backstage/core-plugin-api';
import { scaffolderApiRef } from '@backstage/plugin-scaffolder-react';
import useAsync from 'react-use/lib/useAsync';
import { useScaffolder } from '../../hooks/useScaffolder.esm.js';

const RepoUrlPickerHost = (props) => {
  const { host, hosts, onChange, rawErrors } = props;
  const scaffolderApi = useApi(scaffolderApiRef);
  const [hostsData, setHostsData] = useState([]);
  const [hostList, setHostList] = useState();
  const { githubScaffolderExists, gitlabScaffolderExists, githubHostScaffolder, gitlabHostScaffolder } = useScaffolder();
  const itemsList = (data) => {
    if (data !== void 0) {
      const hostss = [];
      data.forEach((item) => {
        hostss.push({
          label: item,
          value: item
        });
      });
      return hostss;
    }
    return [{
      label: "loading",
      value: "loading"
    }];
  };
  const { value: { integrations } = { integrations: [] }, loading } = useAsync(
    async () => {
      return await scaffolderApi.getIntegrationsList({
        allowedHosts: hosts ?? []
      });
    }
  );
  useEffect(() => {
    async function fetchData() {
      try {
        const hostss = [];
        if (githubScaffolderExists) hostss.push(githubHostScaffolder);
        if (gitlabScaffolderExists) hostss.push(gitlabHostScaffolder);
        setHostsData(hostss);
      } catch (err) {
        console.log(err);
      }
    }
    if (!hosts?.length) {
      fetchData();
    } else {
      setHostsData(hosts);
    }
  }, []);
  useEffect(() => {
    const data = itemsList(hostsData);
    setHostList(data !== void 0 ? data : [{ label: "loading ...", value: "loading ..." }]);
  }, [hostsData]);
  useEffect(() => {
    if (!host) {
      if (hosts?.length) {
        onChange(hosts[0]);
      }
    }
  }, [hosts, host, onChange, integrations]);
  const notAvaliable = [{ label: "No hosts available", value: "No hosts available" }];
  const selectOptions = hostList?.length ? hostList : notAvaliable;
  if (loading) {
    return /* @__PURE__ */ React.createElement(Progress, null);
  }
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
    FormControl,
    {
      margin: "normal",
      required: true,
      error: rawErrors?.length > 0 && !host
    },
    /* @__PURE__ */ React.createElement(
      Select,
      {
        native: true,
        disabled: hosts?.length === 1,
        label: "Host",
        onChange: (s) => onChange(String(Array.isArray(s) ? s[0] : s)),
        selected: host,
        items: selectOptions,
        "data-testid": "host-select"
      }
    ),
    /* @__PURE__ */ React.createElement(FormHelperText, null, "Define the git provider")
  ));
};

export { RepoUrlPickerHost };
//# sourceMappingURL=RepoUrlHost.esm.js.map
